import accents from "remove-accents";
import tippy from "tippy.js";

/**
 * Get css breakpoint from body::after
 */
// IE FIX FOR getComputedStyle
if (!window.getComputedStyle) {
    window.getComputedStyle = function (el) {
        this.el = el;
        this.getPropertyValue = function (prop) {
            var re = /(\-([a-z]){1})/g;
            if (prop == 'float') prop = 'styleFloat';
            if (re.test(prop)) {
                prop = prop.replace(re, function () {
                    return arguments[2].toUpperCase();
                });
            }
            return el.currentStyle[prop] ? el.currentStyle[prop] : null;
        };
        return this;
    };
}

const getBreakpoint = (config = { selector: 'body', pseudoElement: '::after' }) => {
    const selector = document.querySelector(config.selector);

    let breakpoint;

    if (selector) {
        breakpoint = window.getComputedStyle(selector, config.pseudoElement).getPropertyValue('content');
    }

    // IE8 DEFAULT VALUE
    if (!breakpoint) {
        breakpoint = 'desktop';
    }

    // IE9-10 REMOVE QUOTE FROM CONTENT STRING
    breakpoint = breakpoint.replace(/["']/g, '');

    if (breakpoint !== window.deviceWidth) {
        window.deviceWidth = breakpoint;
    }

    return breakpoint;
};

const getMenuBreakpoint = () => {
    return getBreakpoint({
        selector: 'header',
        pseudoElement: '::after'
    });
};

/*
* Output Browser name on HTML tag
 */
const outputBrowserNameHTMLtag = () => {
    if (browser) {
        const browserName = browser?.name?.toLowerCase().split(' ').join('-');

        $('html').addClass(`browser-${browserName}`).attr('data-browser', browserName);
    }
};

const outputOSNameHTMLtag = () => {
    if (browser) {
        let osName = browser?.os?.toLowerCase();

        if(osName) {
            if (osName.includes('windows')) {
                osName = 'windows';
            } else if (osName === 'mac os') {
                osName = 'macos';
            } else if (osName !== 'ios'
                && osName !== 'linux') {
                osName = 'other';
            }
        }

        document.documentElement.classList.add(`os-${osName}`);
        document.documentElement.setAttribute('data-os', osName);
    }
};

/*
* Get query string parameter based on their name
 */
const getUrlParameter = (sParam, mode = null) => {
    let searchFrom = window.location.search;

    if (mode) {
        if (mode.hash) {
            searchFrom = window.location.hash;
        }
    }

    let sPageURL = searchFrom.substring(1),
        sURLVariables = sPageURL.split('&');

    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }
};

/*
* Get the current env (www.coveo.com -> www)
*/

const getCurrentEnv = () => {
    return window.location.hostname.split('.')[0];
};

/*
* Add or modify query string parameter of an URL
*/
const addOrModifyQsParameter = (url, key, value) => {
    const expression = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = url.indexOf("?") === -1 ? "?" : "&";
    
    return url.match(expression)
        ? url.replace(expression, `$1${key}=${encodeURIComponent(value)}$2`)
        : `${url}${separator}${key}=${encodeURIComponent(value)}`;
};

const serializeObject = () => {
    /*!
 * jQuery serializeObject - v0.2 - 1/20/2010
 * http://benalman.com/projects/jquery-misc-plugins/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Whereas .serializeArray() serializes a form into an array, .serializeObject()
// serializes a form into an (arguably more useful) object.

    (function($,undefined){
        '$:nomunge'; // Used by YUI compressor.

        $.fn.serializeObject = function(){
            var obj = {};

            $.each( this.serializeArray(), function(i,o){
                var n = o.name,
                    v = o.value;

                obj[n] = obj[n] === undefined ? v
                    : $.isArray( obj[n] ) ? obj[n].concat( v )
                        : [ obj[n], v ];
            });

            return obj;
        };

    })(jQuery);
};

/*
* Detect if url has specific segment
* Append this segment to the form submit tracking
* Ex: resources_webinars, resources_ebooks, contact_demo, etc
 */
const setSegment = () => {
    let url = window.location.pathname.split('/');

    if(url.length <= 3) {
        url = url[url.length - 1];
    } else {
        if(url.indexOf('resources') > -1) {
            url = `${url[url.length - 3]}_${url[url.length - 2]}`;
        } else {
            url = `${url[url.length - 2]}_${url[url.length - 1]}`;
        }
    }

    return url;
};

const preventMaterialSelectDoubleClick = () => {
    if(!$('html').hasClass('ie11')) {
        const selectWrapper = document.querySelectorAll('.select-wrapper');

        if(selectWrapper) {
            selectWrapper.forEach(el => el.addEventListener('click', e => e.stopPropagation()));
        }
    }
};

/*
* Prevent window resize to trigger twice
 */
const debouncer = (func, timeout) => {
    let timeoutID, currentTimeout = timeout || 0;

    return function() {
        let scope = this , args = arguments;
        clearTimeout( timeoutID );

        timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
        }, currentTimeout);
    };
};

/**
 * Function to sort alphabetically an array of objects by some specific key.
 * @param {String} property Key of the object to sort.
 */
const sortArrayOfObject = (property) => {
    let sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        } else {
            return a[property].localeCompare(b[property]);
        }
    };
};

/**
* Remove duplicate objects from an array
* @param {array} Array that contain the objects.
* @param {String} property Key of the object to remove.
 */
const removeDuplicateObjects = (arr, comp) => {
    const array = arr
        .map(e => e[comp])
        // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)
        // eliminate the dead keys & store unique objects
        .filter(e => arr[e]).map(e => arr[e]);

    return array;
};

/**
* Remove duplicate objects from an array
* @param {String} String to minify.
 */
const minifyString = (string) => {
    string = string.replace(/\n/g, '').replace(/\s\s+/g, ' ');

    return string;
};

/*
* Trigger lity.js on element with data-btn-lity
 */
const openLity = () => {
    const $btnOpenLity = $('[data-open-lity]');

    $btnOpenLity.on('click', function() {
        const url = $(this).data('href');

        lity(url);
    });
};

const getLanguage = () => {
    const pathName = window.location.pathname;

    if (pathName.length) {
        const language = pathName.split('/');

        if (language.length) {
            return language[1];
        }
    }
};

/********************************************/
/******** smoothScrollingAnchor *************/
/********************************************/

const smoothScrollingAnchor = data => {
    let scrollOffset = 120;
    let onDone = null;
    let scrollProgress = 0;

    if (data) {
        if ("offset" in data) {
            scrollOffset = data.offset;
        }

        if ("onDone" in data) {
            onDone = data.onDone;
        }
    }

    const completeRoutine = (target, event) => {
        // Callback after animation
        // Must change focus!
        const $target = $(target);

        if (onDone) {
            onDone({
                source: $(event.target)[0],
                target: $target[0]
            });
        }

        if ($target.is(":focus")) { // Checking if the target was focused
            return false;
        } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            //$target.focus(); // Set focus again
        };
    };

    const scrollRoutine = (target, event, progress = 0) => {
        const initialOffsetTop = target.offset().top;

        $('html, body').stop().animate({
            scrollTop: target.offset().top - scrollOffset - Math.abs(parseInt($('header').css('margin-top')))
        }, {
            duration: 1000 * (1 - progress),
            progress: function(animation, progress, remaining) {
                if (initialOffsetTop != target.offset().top
                    && scrollProgress + 0.2 <= progress) {
                    scrollProgress = progress;
                    scrollRoutine(target, event, progress);
                }
            },
            complete: () => {
                completeRoutine(target, event);
            }
        });
    };

    // Select all links with hashes
    $('a[href^="#"]:not(.noscroll)')
        // Remove links that don't actually link to nothing
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                && location.hostname == this.hostname) {
                // Figure out element to scroll to
                let target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();

                    scrollRoutine(target, event);
                }
            }
        });
};

/*
    Sets the max number of lines to be displayed in a given element
*/

const getLineBreaks = textElement => {
    if (!textElement || !textElement.parentNode || textElement.nodeType !== 3) {
        return [];
    }
    
    const range = document.createRange();
    const lines = [];

    range.setStart(textElement, 0);

    const text = textElement.textContent;
    let prevBottom = range.getBoundingClientRect().bottom;
    let lastFound = 0;
    let bottom = 0;

    for (let current = 1; current <= text.length; current++) {
        range.setStart(textElement, current);

        if (current < text.length - 1) {
            range.setEnd(textElement, current + 1);
        }

        bottom = range.getBoundingClientRect().bottom;

        if (bottom > prevBottom) {
            lines.push(text.substr(lastFound, current - lastFound - 1));
            
            prevBottom = bottom;
            lastFound = current - 1;
        }
        current++;
    }

    lines.push(text.substr(lastFound));
  
    return lines;
};

const setMaxLines = (element, maxLines) => {
    const lines = getLineBreaks(element.childNodes[0]);

    let newTextContent = '';
    if (lines.length > maxLines) {
        for (let i = 0; i < maxLines; i++) {
            newTextContent += lines[i];
        }

        element.textContent = newTextContent.slice(0, -3) + '...';
    }
};
/*
* Load Vue/js runtime DEV or PRODUCTION  script
* componentName: The attribute name in data-vue-component. Ex: data-vue-component="accordionBox"
*/
const initVue = (config = {}) => {
    const then = config.then || null;
    const componentName = config.componentName || null;
    const env = window.location.hostname.split('.')[0];
    const prodUrls = ['stagingenv', 'prodcmenv', 'www'];
    const isDev = (env.indexOf(prodUrls) === -1);
    const scriptID = 'vuejsruntime';

    let vuejsScriptUrl = '/public/js/external/vuejs/vue.v2.6.12.js';

    if(!isDev) {
        vuejsScriptUrl = '/public/js/external/vuejs/vue.min.v2.6.12.js';
    }

    // IE 11 fix
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    /*
    * Load Vue.js runtime javascript once.
    * If vue has loaded, init the component only
     */
    if($(`[data-vue-component="${componentName}"]`).length) {
        if(typeof Vue === 'undefined' && !$(`#${scriptID}`).length) {
            loadJS(vuejsScriptUrl, function() {
                if(then) {
                    then();
                }
            }, null, null, scriptID, false);
        } else {
            const interval = setInterval(() => {
                if(typeof Vue !== 'undefined') {
                    clearInterval(interval);

                    if(then) {
                        then();
                    }
                }
            }, 250);
        }
    }
};

/*
* Select an <option> in a <select> based not on its value, but on it's text
*/

const selectTextOption = (element, optionText) => {
    const optionTextClean = accents.remove(optionText.toLowerCase());
    
    $(`${element} option`).filter((index, option) => accents.remove($(option).html().toLowerCase()) == optionTextClean).attr('selected', 'selected').trigger('change');
};

/*
* Initiate Tooltip with Default Custom Theme
 */
const initializeToolTips = () => {
    const tippyContent = document.querySelectorAll('[data-tippy-content]');

    if(tippyContent.length) {
        tippyContent
        .forEach(element => {
            const theme = element.dataset.tippyTheme || 'classico';
            const placement = element.dataset.tippyPlacement || 'top';

            tippy(element, {
                theme,
                interactive: true,
                interactiveBorder: 10,
                allowHTML: true,
                animation: false,
                placement
            });
        });
    }
};

/*
* Generate random ID
 */
const randomID  = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    let result = '';

    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};

const getRandomIntInclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
};

const getRandomFloat = (min, max) => {
    return Math.random() * (max - min) + min;
};

const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), replace);
};

export {
    getBreakpoint,
    getMenuBreakpoint,
    serializeObject,
    getUrlParameter,
    getCurrentEnv,
    addOrModifyQsParameter,
    setSegment,
    preventMaterialSelectDoubleClick,
    debouncer,
    sortArrayOfObject,
    removeDuplicateObjects,
    minifyString,
    openLity,
    smoothScrollingAnchor,
    getLanguage,
    setMaxLines,
    initVue,
    selectTextOption,
    outputBrowserNameHTMLtag,
    outputOSNameHTMLtag,
    initializeToolTips,
    randomID,
    replaceAll,
    getRandomIntInclusive,
    getRandomFloat
};